import { Theme } from "@mui/material/styles";
import { HMO } from "constants/hmo";
import { detectHmo } from "utils/hmoDetection";
import rgba from "assets/theme/functions/rgba";

interface Styles {
  [key: string]: any;
}

const isLeumit = detectHmo() === HMO.LEUMIT;

export const styles = (theme: Theme): Styles => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%",
    padding: `${theme.spacing.spacing2} 0`,
    overflowY: "auto",
    overflowX: "hidden",
    justifyContent: "space-between",
  },
  submittingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.spacing10,
    backgroundColor: rgba(theme.palette.white.main, 0.75),
    zIndex: theme.zIndex.modal,
  },
  helperText: {
    fontSize: theme.typography.size.md,
    textAlign: "center",
    marginBottom: theme.spacing.spacing4,
    color: theme.palette.text.primary,
    lineHeight: theme.typography.lineHeight.sm,
    padding: `0 ${theme.spacing.spacing5}`,
    ...(isLeumit && {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.size.sm,
      padding: 0,
      marginBottom: theme.spacing.spacing10,
    }),
  },
  optionsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: theme.spacing.spacing15,
    marginBottom: theme.spacing.spacing5,
    alignItems: "stretch",
    padding: `0 ${theme.spacing.spacing5}`,
    flexWrap: "nowrap",
    width: "100%",
  },
  optionCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.spacing5} `,
    borderRadius: theme.borders.borderRadius.lg,
    border: isLeumit
      ? `1px solid ${theme.palette.primary.main}`
      : `1px solid ${theme.palette.text.secondary}`,
    backgroundColor: theme.palette.transparent.main,
    cursor: "pointer",
    transition: "all 0.3s ease",
    flex: 1,
    maxWidth: "150px",
    justifyContent: "space-between",
    font: "inherit",
    color: "inherit",
    textAlign: "center",
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },
  optionCardSelected: {
    border: isLeumit
      ? `4px solid ${theme.palette.primary.main}`
      : `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.boxShadows.lg,
  },
  optionLinesText: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: "center",
  },
  optionImage: {
    marginBottom: theme.spacing.spacing10,
    marginTop: theme.spacing.spacing10,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  optionLabel: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    textAlign: "center",
    // marginTop: theme.spacing.spacing5,
  },
  buttonsSection: {
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full,
    paddingTop: theme.spacing.spacing5,
    paddingBottom: theme.spacing.spacing2,
    flexShrink: 0,
  },
  sendInstructionsText: {
    fontSize: theme.typography.size.xs,
    textAlign: "center",
    marginBottom: theme.spacing.spacing5,
    whiteSpace: "pre-line",
    lineHeight: '20px',
  },
});
